import { memo } from "react";
import { useSelector } from "react-redux";
import LocalActivityIcon from '@mui/icons-material/LocalActivity';
import LocalActivityOutlinedIcon from '@mui/icons-material/LocalActivityOutlined';

const NoTicket = (props: { createNewTicket: () => void }) => {

  const design = useSelector((state: any) => state?.design);

  return (
    <>
      <div id='ele-68' className="flex flex-col justify-around h-full">
        <div id='ele-69' className="flex flex-col h-fit items-center">
          <div id='ele-70' className="mb-3">
            <LocalActivityIcon className={`align-middle !text-5xl text-footer`} />
          </div>
          <div id='ele-71' className="text-primaryText text-lg font-mSemiBold pb-1">No Tickets Created Yet</div>
          <div id='ele-72' className="text-gray-400 text-xs text-center pb-7 px-8">You haven’t created any help tickets. If you need assistance, please create a new ticket.</div>
          <div
            id='ele-73'
            className="align-middle justify-center items-center text-white rounded-lg px-6 py-2 cursor-pointer shadow-md"
            style={{ backgroundColor: design?.themeColor }}
            onClick={props.createNewTicket}
          >
            <LocalActivityOutlinedIcon className={`!text-xl align-middle justify-center items-center`} />
            <button id='ele-74' className="align-bottom ml-2">
              Create New Ticket</button>
          </div>
        </div>
      </div>
    </>
  );
}

export default memo(NoTicket);

